export const MINIMUM_MYSQL_DATE = new Date('1970-01-01T00:00:00Z');
